import axios from 'axios'

// 1. 创建 axios 实例
const service = axios.create({
  baseURL: 'https://dailyshort.cn', // 替换为你的 API 基础地址
  timeout: 30000, // 请求超时时间
  headers: { 'Content-Type': 'application/jsoncharset=utf-8' }
})

// 2. 请求拦截器 (Request Interceptor)
service.interceptors.request.use(
  config => {
    // 在这里可以统一添加 header等信息
    // config.headers['x-debug'] = 'true'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 3. 响应拦截器 (Response Interceptor)
service.interceptors.response.use(
  response => {
    const res = response.data
    logger.debug('网络请求成功:', res)
    // 这里可以根据后端返回的状态码进行逻辑处理（如 200 成功，其他失败）
    if (res.code !== 0) {
      console.error('错误消息：', res.msg || 'Error')
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    return res.data
  },
  error => {
    if (error.response && error.response.data) {
      console.error('网络请求错误：', error.response.data)
      return Promise.reject(new Error(error.response.data))
    } else {
     // 统一处理 HTTP 错误状态码 (401, 404, 500 等)
     console.error('网络请求错误：', error)
     return Promise.reject(error)
    }
  }
)

export default service
